import { IModalProps } from "@atoms/ZModal/interface";
import Uppy, { UppyFile } from "@uppy/core";

export enum UppyAllowedFileTypes {
	ALL = "*/*",
	IMAGE = "image/jpg,image/jpeg,image/png,image/gif,image/svg,image/webp, image/svg+xml",
	VIDEO = "video/mp4,.mkv,video/webm,video/x-matroska,application/octet-stream",
	PDF = "application/pdf",
	FAVICON = "image/vnd.microsoft.icon,image/x-icon",
	EXCEL = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel",
	CSV = ".csv",
	DOCX = ".docx,.doc",
	TSV = ".tsv",
	TXT = ".txt",
	XML = ".xml",
	PPTX = ".ppt,.pptx",
	XLSX = ".xls,.xlsx"
}

export const NotAllowedExtensions = /\.(exe|js|htaccess)$/gi;

export interface IFileUploadProps {
	readonly maxFileSize?: number;
	readonly maxNumberOfFiles?: number;
	readonly minNumberOfFiles?: number;
	readonly allowedFileTypes: UppyAllowedFileTypes[];
	readonly allowMultipleUploads?: boolean;
	readonly errorMessage?: string;
	readonly uploadingText?: string;
	readonly uploadSuccessMessage?: string;
	readonly useURL?: boolean;
	readonly isEmailAttachment?: boolean;
	readonly useModal?: IModalProps;
	readonly showFileMetaInfoText?: boolean;
	readonly skipUploadingToNylas?: boolean;
	readonly onUploadStart?: () => void;
	readonly onUploadSuccess?: (
		result: Uppy.UploadResult<UppyFileMetaData>
	) => void;
	readonly onEachUploadSuccess?: (file: UppyFile, response: any) => void;
	readonly onCancel?: () => void;
	readonly path?: string;
	readonly compressImages?: boolean;
	readonly allowYoutubeLink?: boolean;
	readonly alert?: JSX.Element;
}

export interface IOnBeforeAddedFunction {
	(currentFile: UppyFile, _files: Record<string, UppyFile>):
		| boolean
		| UppyFile;
}

export interface IOnBeforeUploadFunction {
	(files: Record<string, UppyFile>): Record<string, UppyFile>;
}

export enum UploadStage {
	FILE_SELECT,
	UPLOAD_LINK,
	UPLOADING_IN_PROGRESS,
	UPLOADING_DONE
}

export interface UppyFileMetaData {
	width?: number;
	height?: number;
	thumbnail?: string;
}
